import React, { useState, useEffect } from "react";
import styled from "@emotion/styled/macro";
import { TriangleUpIcon, TriangleDownIcon } from "@chakra-ui/icons";
import { css } from "@emotion/react";
import { LANGUAGES } from "../../../i18n";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

const dynamicStyle = (props) =>
  css`
    color: ${props.color};
    border: 1px solid ${props.color};
    margin: ${props.margin};
  `;

const Wrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 4em;
    margin: 0;
  }
  align-self: baseline;
  max-width: 5em;
  margin-bottom: 15em;
  ${dynamicStyle};
`;
const Trigger = styled.div`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  text-align: center;
`;
const ListItem = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    position: absolute;
  }
  position: relative;
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  ${dynamicStyle};
`;
const MenuItem = styled.div`
  color: black;
  display: block;
  font-size: 15px;
  padding: 0 10px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.opal};
  &:hover {
    background-color: ${({ theme }) => theme.colors.opal};
    color: ${({ theme }) => theme.colors.white};
  }
`;
function LanguageBox({ colorTheme }) {
  const { i18n } = useTranslation();

  const location = useLocation();
  const history = useHistory();

  const lang = i18n.language;

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  useEffect(() => {
    if (LANGUAGES.includes(lang) && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
    if (LANGUAGES.includes(lang) && params.language !== i18n.language) {
      i18n.changeLanguage(params.language === "en" ? "eng" : params.language);
    }
  }, [lang, i18n.language, params.language, location.pathname, history, i18n]);

  const handleLanguageChange = (e, language) => {
    e.preventDefault();
    i18n.changeLanguage(language);
    window.location.reload();
  };

  const [isOpen, setOpen] = useState(false);
  const trigger = () => {
    setOpen(!isOpen);
  };
  const close = () => {
    setOpen(false);
  };

  return (
    <Wrapper color={colorTheme}>
      <Trigger onClick={trigger}>
        {" "}
        {isOpen ? <TriangleUpIcon w={3} h={3} /> : <TriangleDownIcon w={3} h={3} />} {i18n.language?.toUpperCase()}
      </Trigger>
      {isOpen && (
        <ListItem onClick={close} color={colorTheme}>
          {LANGUAGES.map((language) => (
            <MenuItem
              color={colorTheme}
              onClick={(e) => handleLanguageChange(e, language)}
              active={language === i18n.language}
            >
              {language.toUpperCase()}
            </MenuItem>
          ))}
        </ListItem>
      )}
    </Wrapper>
  );
}

export default LanguageBox;
